<template>
  <div id="CartoonKid">
    <div class="mask-box" :style="{ width: `${maskWidth}%`, height: `${maskHeight}%` }">
      <!-- 右侧小人 -->
      <div id="moveSide" :class="{ 'side-kid-box': true }" :style="rightSidePosition" v-if="isShowSide && !isSideLeft" @mousedown="pressSideDown($event, true)" @mousemove="pressSideMove($event, true)" @mouseup="pressSideEnd($event, true)" @touchstart="pressSideDown($event, true)" @touchmove="pressSideMove($event, true)" @touchend="pressSideEnd($event, true)">
        <img class="side-kid-img" :style="{ opacity: isSwitchSide || isSwitchStand ? 1 : 0.8 }" :src="rightSideImg" alt="" @click="switchImg(false, false)" />
      </div>

      <!-- 左侧小人 -->
      <div id="moveSide" :class="{ 'side-kid-box': true }" :style="leftSidePosition" v-if="isShowSide && isSideLeft" @mousedown="pressSideDown($event, true)" @mousemove="pressSideMove($event, true)" @mouseup="pressSideEnd($event, true)" @touchstart="pressSideDown($event, true)" @touchmove="pressSideMove($event, true)" @touchend="pressSideEnd($event, true)">
        <img class="side-kid-img" :style="{ opacity: isSwitchSide || isSwitchStand ? 1 : 0.8 }" :src="leftSideImg" alt="" @click="switchImg(false, true)" />
      </div>

      <!-- 站立小人 -->
      <!-- <div v-if="!isShowSide">
                <stand-kid
                    ref="standRef"
                    :isSwitchStand.sync="isSwitchStand"
                    :position="standPosition"
                    @callKid="callKid">
                    <img
                        class="stand-kid-img"
                        :style="{opacity: (isSwitchSide || isSwitchStand) ? 1 : 0.8}"
                        :src="standImg" alt=""
                        @click="switchImg(true)">
                </stand-kid>
            </div> -->
      <div v-if="!isShowSide" id="moveDiv" :style="standPosition" :class="{ 'stand-kid-house': true }" @mousedown="pressStandDown($event)" @mousemove="pressStandMove($event)" @mouseup="pressStandEnd($event)" @touchstart="pressStandDown($event)" @touchmove="pressStandMove($event)" @touchend="pressStandEnd($event)">
        <img class="stand-kid-img" :style="{ opacity: isSwitchSide || isSwitchStand ? 1 : 0.8 }" :src="standImg" alt="" @click="switchImg(true)" />

      </div>
    </div>

    <!-- 点击站立小人后弹窗 -->
    <div v-if="showSetting">
      <setting-pop @showRest="showRest" @changeHome="changeHome" @closePop="closePop">
      </setting-pop>
    </div>
  </div>
</template>

<script>
  // import { mapGetters } from 'vuex';
  // import standKid from "./standKid";
  import settingPop from "./setting-pop";
  import { decryptBy } from '@/assets/js/encryption';
  export default {
    name: "cartoon-kid",
    components: {
      settingPop,
      // standKid
    },
    props: {
      closeSetting: {
        type: Boolean,
        default: false, // handleMedicine 事件需关闭
      },
      homeUserInfo: {
        type: Object,
        default: () => ({}),
      },
      kidGender: {
        type: String,
        default: "",
      },
    },
    data() {
      return {
        maskWidth: 0,
        maskHeight: 0,
        leftSide: require("../../assets/images/cartoon-kid/left.png"),
        rightSide: require("../../assets/images/cartoon-kid/right.png"),
        stand: require("../../assets/images/cartoon-kid/stand.png"),
        isSwitchSide: false, // 是否切换 侧边小人透明度
        isSwitchStand: false, // 是否切换 站立小人透明度
        isShowSide: true, // 控制显示站立 or 侧边小人
        isSideLeft: false, // 是否是左侧小人
        startSideFlag: false,
        pressSidePositon: { x: 0, y: 0 }, // 手指位置
        // variationSideX: '', // 手指移动变化量
        variationSideY: "", // 手指移动变化量
        sideX: "", // 移动盒子初始位置
        sideY: "", // 移动盒子初始位置
        sideEndX: "", // 移动盒子最终位置
        sideEndY: "", // 移动盒子最终位置
        leftSidePosition: {
          top: "415px",
          left: "0px",
          textAlign: "left",
        },
        rightSidePosition: {
          top: "415px",
          right: "0px",
          textAlign: "right",
        },
        standPosition: {
          top: "385px",
          right: "30px",
        },
        /* ----------- */
        startStandFlag: false,
        pressPositon: { x: 0, y: 0 }, // 记录手指点击的位置
        variationX: "", // 手指移动变化量
        variationY: "", // 手指移动变化量
        standX: "", // 移动盒子初始位置
        standY: "", // 移动盒子初始位置
        standEndX: "", // 移动盒子最终位置
        standEndY: "", // 移动盒子最终位置
        showSetting: false, // 控制显示 站立小人弹窗
        timetableVisible: false, // 控制 站立小人弹窗——生活作息按钮 弹窗
      };
    },
    computed: {
      rightSideImg() {
        return this.giveKidImg(this.rightSide);
      },
      leftSideImg() {
        return this.giveKidImg(this.leftSide);
      },
      standImg() {
        return this.giveKidImg(this.stand);
      },
    },
    watch: {
      isSwitchSide(newVal) {
        if (newVal && !this.startSideFlag) {
          setTimeout(() => {
            this.isSwitchSide = false;
          }, 3000);
        }
      },
      isSwitchStand(newVal) {
        if (newVal && !this.startStandFlag) {
          setTimeout(() => {
            this.isSwitchStand = false;
          }, 3000);
        }
      },
      startSideFlag(val) {
        if (!val) {
          setTimeout(() => {
            this.isSwitchSide = false;
          }, 3000);
        }
      },
      startStandFlag(val) {
        if (!val) {
          setTimeout(() => {
            this.isSwitchStand = false;
          }, 3000);
        }
      },
    },
    created() { },
    mounted() { },
    methods: {
      giveKidImg(boy) {
        return boy
      },
      switchImg(isback, isLeft) {
        // 点击侧边小人
        if (!isback) {
          this.isSwitchSide = true;

          setTimeout(() => {
            // 保证左侧边小人点击出来的事左边站立小人
            if (isLeft) {
              this.standPosition.left = "25px";
              this.standPosition.top = this.leftSidePosition.top;
            } else {
              delete this.standPosition.left;
              this.standPosition.top = this.rightSidePosition.top;
            }
            this.isShowSide = false;
          }, 100);
        } else {
          this.isSwitchStand = true;

          // 点击站立小人，出现设置弹框
          setTimeout(() => {
            this.showSetting = true;
          }, 100);
        }
      },
      callKid(showSide, sideLeft) {
        this.isShowSide = showSide;
        this.isSideLeft = sideLeft;
      },
      pressSideDown(event, isSide, direction) {
        this.startSideFlag = true;
        this.isSwitchSide = this.isSwitchStand = true;
        let touch;
        // 该if判断是用touch还是mouse来移动
        if (event.touches) {
          touch = event.touches[0];
        } else {
          touch = event;
        }
        this.pressSidePositon.x = touch.clientX; // 手指点击后的位置
        this.pressSidePositon.y = touch.clientY;
        this.sideX = moveSide.offsetLeft; // 移动的div元素的位置
        this.sideY = moveSide.offsetTop;
      },
      pressSideMove(event, isSide, direction) {
        if (this.startSideFlag) {
          this.maskWidth = this.maskHeight = 100;
          let touch;
          if (event.touches) {
            touch = event.touches[0];
          } else {
            touch = event;
          }

          // this.variationSideX = touch.clientX - this.pressSidePositon.x;   // 手指移动的变化量
          this.variationSideY = touch.clientY - this.pressSidePositon.y;

          // this.sideEndX = this.sideX + this.variationSideX;   // 移动后，div元素的位置
          this.sideEndY = this.sideY + this.variationSideY;

          // let windowWidth = document.documentElement.clientWidth;
          let windowHeight = document.documentElement.clientHeight;

          // 上下未出界
          if (
            this.sideEndY > 0 &&
            this.sideEndY + moveSide.clientHeight < windowHeight
          ) {
            moveSide.style.top = this.sideEndY + "px";
            this.standPosition.top = moveSide.style.top;
          } else if (this.sideEndY <= 0) {
            // 上边缘出界
            moveSide.style.top = 0 + "px";
            this.standPosition.top = moveSide.style.top;
          } else if (this.sideEndY + moveSide.clientHeight >= windowHeight) {
            // 下边缘出界
            moveSide.style.top = windowHeight - moveSide.clientHeight + "px";
            this.standPosition.top = moveSide.style.top;
          }

          document.addEventListener("touchmove", this.preventDefault(event), {
            passive: false,
          });
          document.addEventListener("mousemove", this.preventDefault(event), {
            passive: false,
          });
        }
      },
      // 先触发touch事件，再触发click事件
      pressSideEnd(event, isSide, direction) {
        this.startSideFlag = false;
        this.maskWidth = this.maskHeight = 0;
      },
      preventDefault(e) {
        e.preventDefault();
      },
      // 实现移动端拖拽
      pressStandDown(event) {
        if (this.fixed) {
          return;
        }

        this.startStandFlag = true;
        this.isSwitchSide = this.isSwitchStand = true;

        let touch;
        // 该if判断是用touch还是mouse来移动
        if (event.touches) {
          touch = event.touches[0];
        } else {
          touch = event;
        }
        this.pressPositon.x = touch.clientX; // 手指点击后的位置
        this.pressPositon.y = touch.clientY;

        this.standX = moveDiv.offsetLeft; // 移动的div元素的位置
        this.standY = moveDiv.offsetTop;
      },
      pressStandMove(event) {
        if (this.startStandFlag) {
          this.maskWidth = this.maskHeight = 100;

          let touch;
          if (event.touches) {
            touch = event.touches[0];
          } else {
            touch = event;
          }

          this.variationX = touch.clientX - this.pressPositon.x; // 手指移动的变化量
          this.variationY = touch.clientY - this.pressPositon.y;

          this.standEndX = this.standX + this.variationX; // 移动后，div元素的位置
          this.standEndY = this.standY + this.variationY;

          this.windowWidth = document.documentElement.clientWidth;
          this.windowHeight = document.documentElement.clientHeight;

          // movediv的左右边，未出界
          if (
            this.standEndX > 0 &&
            this.standEndX + moveDiv.clientWidth < this.windowWidth
          ) {
            moveDiv.style.left = this.standEndX + "px";
          } else if (this.standEndX <= 10) {
            // 左边出界，则左边缘贴边
            // moveDiv.style.left = 0 + 'px';
            this.isShowSide = true;
            this.isSideLeft = true;
          } else if (this.standEndX + moveDiv.clientWidth >= this.windowWidth) {
            // 右边缘出界
            // moveDiv.style.left = (this.windowWidth - moveDiv.clientWidth) + 'px';
            // this.standPosition.left = (this.windowWidth - moveDiv.clientWidth + 5) + 'px';

            this.$nextTick(() => {
              this.isShowSide = true;
              this.isSideLeft = false;
            });
          }

          // 上下未出界
          if (
            this.standEndY > 0 &&
            this.standEndY + moveDiv.clientHeight < this.windowHeight
          ) {
            moveDiv.style.top = this.standEndY + "px";
            this.isSideLeft
              ? (this.leftSidePosition.top = moveDiv.style.top)
              : (this.rightSidePosition.top = moveDiv.style.top);
          } else if (this.standEndY <= 0) {
            // 上边缘出界
            moveDiv.style.top = 0 + "px";
            this.isSideLeft
              ? (this.leftSidePosition.top = moveDiv.style.top)
              : (this.rightSidePosition.top = moveDiv.style.top);
          } else if (this.standEndY + moveDiv.clientHeight >= this.windowHeight) {
            // 下边缘出界
            moveDiv.style.top = this.windowHeight - moveDiv.clientHeight + "px";
            this.isSideLeft
              ? (this.leftSidePosition.top = moveDiv.style.top)
              : (this.rightSidePosition.top = moveDiv.style.top);
          }

          // 阻止页面的滑动默认事件，为了只让悬浮球滑动，其他部分不滑动；如果碰到滑动问题，1.2 请注意是否获取到 touchmove, 系统默认passive: true，无法使用preventDefault
          // document.addEventListener('touchmove', function(){
          //    event.preventDefault();
          // }, { passive: false });
          // document.addEventListener('mousemove', function(){
          //     event.preventDefault();
          // }, { passive: false });
          // document.addEventListener('touchmove', this.preventDefault(event), { passive: false });
          // document.addEventListener('mousemove', this.preventDefault(event), { passive: false });
        }
      },
      //鼠标释放时候的函数，鼠标释放，移除之前添加的侦听事件，将passive设置为true，不然背景会滑动不了
      pressStandEnd(event) {
        this.startStandFlag = false;
        this.maskWidth = this.maskHeight = 0;

        // 注意事项，在添加和删除监听事件时，其function必须是同名的函数，不能为匿名函数。
        // document.removeEventListener('touchmove',this.preventDefault(event), false);
        // document.removeEventListener('mousemove',this.preventDefault(event), false);

        // 下面两句是保证在移除监听事件后，除了悬浮球的部分还能够滑动，如果不添加，则无法滑动
        // document.addEventListener('touchmove', function(e) {
        //     window.event.returnValue = true;
        // })
        // document.addEventListener('mousemove', function(e) {
        //     window.event.returnValue = true;
        // })
      },
      changeHome(data) {
        // 2是自定义首页，4是系统首页
        // this.tabStatus = data;

        // 暴露给首页父组件，切换首页
        this.$emit("changeHome", data);
        this.showSetting = false;
      },
      closePop(data) {
        this.showSetting = false;
        if (data === "jumpAfter") {
          this.isShowSide = true;
        }
      },
      showRest(data) {
        // this.getLifeTime();
        this.timetableVisible = true;
      },
    },
  };
</script>

<style scoped lang="scss">
  #CartoonKid {
    .mask-box {
      position: fixed;
      z-index: 2002; // /self 页面底部弹框多数时候是 2002，提示是否保存的对话框 2009 or 2003 不能比这个大
      top: 0;
      right: 0;
      background-color: transparent;
      // background-color: rgba(0, 0, 0, 0.4);
      // width: 100%;
      // height: 100%;
    }
    .side-kid-box {
      // width: 80px;
      // height: 80px;
      // text-align: right;
      position: fixed;
      // top: 415px;

      z-index: 2002; // /self 页面底部弹框多数时候是 2002，提示是否保存的对话框 2009 or 2003 不能比这个大
      img {
        width: 66px;
        // height: 69px;
      }
    }
    .stand-kid-img {
      width: 66px;
      // height: 63px;
    }
    .stand-kid-house {
      position: fixed; // 这里的定位方式有待考量，fixed的话存在未知设置不合理，跑出屏幕不显示的问题
      z-index: 2002;
      width: 40px;
      height: 89px;
    }
  }
</style>
